import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import type { UserSubstitutionItem } from 'types/user';

interface UseSubstitutionDetailNavigationProps {
  basePath: string;
  editPath: string;
}

interface UseSubstitutionDetailNavigationReturn {
  id: string | undefined;
  handleBack: () => void;
  handleEdit: () => void;
  handleErrorRedirect: (isError: boolean, isLoading: boolean, substitution?: UserSubstitutionItem) => void;
}

export function useSubstitutionDetailNavigation({ basePath, editPath }: UseSubstitutionDetailNavigationProps): UseSubstitutionDetailNavigationReturn {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleBack = useCallback(() => {
    navigate(basePath);
  }, [navigate, basePath]);

  const handleEdit = useCallback(() => {
    navigate(`${editPath}/${id}`);
  }, [navigate, editPath, id]);

  const handleErrorRedirect = useCallback(
    (isError: boolean, isLoading: boolean, substitution?: UserSubstitutionItem) => {
      if (isError || (!isLoading && !substitution)) {
        navigate(basePath, { replace: true });
      }
    },
    [navigate, basePath]
  );

  return {
    id,
    handleBack,
    handleEdit,
    handleErrorRedirect,
  };
}
